import React from "react";

import { saveComplexPromotion } from "@admin/domain/complexPromotions/api";
import Editor from "@admin/components/Editor";
import Common from "./Common";
import AmountPromotion from "./AmountPromotion";
import ContentPromotion from "./ContentPromotion";
import PromoCodePromotion from "./PromoCodePromotion";

const LIST_URL = `/admin/complex_promotions` as const;

type Props = {
    type?: `amount` | `content` | `promocode`;
};

const promotionComponents = {
    amount: AmountPromotion,
    content: ContentPromotion,
    promocode: PromoCodePromotion,
};

type PromotionType = keyof typeof promotionComponents;

const ComplexPromotionEditor: React.FC<Props> = (props) => {
    const promotion = window.CMS.complexPromotion || null;

    const execute = async (body: FormData) => {
        await saveComplexPromotion(promotion, body);
    };

    const reset = () => {
        // Чтобы сбросить добавленные уровни, проще всего перезагрузить страницу.
        window.location.reload();
    };

    const type: PromotionType = promotion?.type || props.type || `amount`;
    const PromotionComponent = promotionComponents[type];

    if (!PromotionComponent) {
        throw new Error(`Unknown promotion type: ${type}`);
    }

    return (
        <Editor
            backUrl={promotion ? `/admin/complex_promotions/${promotion.id}` : LIST_URL}
            onSubmit={execute}
            onReset={reset}
        >
            <Common type={type} promotion={promotion} />
            <PromotionComponent promotion={promotion} />
        </Editor>
    );
};

export default ComplexPromotionEditor;
